import { color } from "../stylesGlobal";

export const dark = {
    colors: {
        cinza: "#A0A0A0",
        red: "#F03232",

        background: "#1C1C1C",
        backgroundSecondary: "#222225",

        textTitle: color.white,
        textBody: "#D9D9D9",

        categoryContainer: "#222225",
        categoryBoxIcon: color.main,
        categoryIcon: color.white,

        cardVerticalBackground: "#26242C",

        cardHorizontalBackground: "#26242C",
        cardHorizontalBackgroundSecondary: "#222225",

        inputsBackground: "#1C1C1C",
        inputsPlaceholder: "#C9C9C9",
        inputsText: color.white,

        buttonGreen: "#8fc227",
        buttonRed: "#F03232",
    }
}
